import React from 'react';
import { useTranslation } from 'react-i18next';
import { maxMobileSize } from '../../../utils/constants';
import AppliedJobCard from '../Cards/AppliedJobCard/AppliedJobCard';
import { useWindowSize } from '../../../utils/hooks';
import JobCardSkeleton from '../Skeletons/JobCardSkeleton';
import EmptyList from '../EmptyList/EmptyList';
import Table from '../Table/Table';
import { appliedJobsConstant } from './helpers/appliedJobs';

function AppliedJobsList(props) {
  const { jobsData, pendingFetch } = props;

  const { t } = useTranslation();
  const size = useWindowSize();

  if ((!Array.isArray(jobsData) || jobsData.length === 0) && pendingFetch === false) {
    return (
      <EmptyList
        mainTitle={t('dashboard.jobs.emptylist.appliednojobs')}
        secondaryTitle={t('dashboard.jobs.emptylist.appliedsecondary')}
        buttonTitle={t('dashboard.jobs.emptylist.appliedsecondary')}
        routeForNavigation="/dashboard/jobs"
      />
    );
  }

  return size.width > maxMobileSize ? (
    <Table cols={appliedJobsConstant(t)} data={jobsData} pendingFetch={pendingFetch} />
  ) : (
    <div data-testid="mobile" className="d-flex flex-column gap-2 mb-3">
      {/* eslint-disable-next-line no-nested-ternary */}
      {pendingFetch ? (
        Array.from({ length: 5 }, (v, k) => k)
          // eslint-disable-next-line react/no-array-index-key
          .map((_, idx) => <JobCardSkeleton key={idx} qty={6} />)
      ) : jobsData?.length === 0 || !Array.isArray(jobsData) ? (
        <h6>{t('dashboard.jobs.appliedlist.nojobs')}</h6>
      ) : (
        jobsData.map((item) => (
          <AppliedJobCard
            key={item.JobId}
            job={item.Job}
            jobId={item.JobId}
            cretedDate={item.CreatedDate}
            status={item?.JobApplicationStatus?.UIName}
            dots={false}
          />
        ))
      )}
    </div>
  );
}

export default AppliedJobsList;
